import React from "react";
import LegalLayout from "@/components/legal/LegalLayout";
import { COMPANY } from "@/lib/company";

export default function Impressum() {
  return (
    <LegalLayout
      title="Impressum"
      lead="Angaben gemäß § 5 TMG."
      testId="impressum-page"
    >
      <h2>Anbieter</h2>
      <p>
        {COMPANY.name}
        <br />
        {COMPANY.street}
        <br />
        {COMPANY.zip} {COMPANY.city}
        <br />
        {COMPANY.country}
      </p>

      <h2>Kontakt</h2>
      <p>
        Telefon:{" "}
        <a href={`tel:${COMPANY.phoneHref}`}>{COMPANY.phone}</a>
        <br />
        Telefax: {COMPANY.fax}
        <br />
        E-Mail: <a href={COMPANY.emailHref}>{COMPANY.email}</a>
        <br />
        Internet:{" "}
        <a
          href={`https://${COMPANY.website}`}
          target="_blank"
          rel="noreferrer"
        >
          {COMPANY.website}
        </a>
      </p>

      <h2>Vertretungsberechtigter Geschäftsführer</h2>
      <p>{COMPANY.ceo}</p>

      <h2>Eintragung im Handelsregister</h2>
      <p>
        Registergericht: {COMPANY.register}
        <br />
        Registernummer: {COMPANY.registerNumber}
      </p>

      <h2>Umsatzsteuer-Identifikationsnummer</h2>
      <p>
        Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:{" "}
        <strong>{COMPANY.vatId}</strong>
      </p>

      <h2>WEEE-Registrierung</h2>
      <p>
        WEEE-Reg.-Nr.: <strong>{COMPANY.weee}</strong>
      </p>

      <h2>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
      <p>
        {COMPANY.ceo}
        <br />
        {COMPANY.street}, {COMPANY.zip} {COMPANY.city}
      </p>

      <h2>Online-Streitbeilegung</h2>
      <p>
        Die EU-Kommission stellt eine Plattform zur Online-Streitbeilegung (OS)
        bereit:{" "}
        <a
          href="https://ec.europa.eu/consumers/odr"
          target="_blank"
          rel="noreferrer"
        >
          https://ec.europa.eu/consumers/odr
        </a>
        . Wir sind nicht verpflichtet und nicht bereit, an einem
        Streitbeilegungsverfahren vor einer Verbraucher­schlichtungs­stelle
        teilzunehmen.
      </p>

      <h2>Haftung für Inhalte</h2>
      <p>
        Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die
        Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir
        jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß
        § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen
        Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als
        Diensteanbieter jedoch nicht verpflichtet, übermittelte oder
        gespeicherte fremde Informationen zu überwachen oder nach Umständen zu
        forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
      </p>

      <h2>Haftung für Links</h2>
      <p>
        Unser Angebot enthält Links zu externen Websites Dritter, auf deren
        Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden
        Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten
        Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten
        verantwortlich.
      </p>

      <h2>Urheberrecht</h2>
      <p>
        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen
        Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung,
        Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
        Grenzen des Urheberrechts bedürfen der schriftlichen Zustimmung des
        jeweiligen Autors bzw. Erstellers.
      </p>
    </LegalLayout>
  );
}
